import apiClient from "../client";
const ENDPOINT = "/courses"

export const coursesApi = {
    getList: ({ page = 1, pageSize = 10, sortBy = '-id', filter = {} }) =>
        apiClient.get(ENDPOINT, { params: { page, pageSize, sortBy, filter } }),
    getDetail: (id) => apiClient.get(`${ENDPOINT}/${id}`),
    create: (payload) => apiClient.post(ENDPOINT, payload),
    update: (payload) => apiClient.put(`${ENDPOINT}/${payload.id}`, payload),
    delete: (id) => apiClient.delete(`${ENDPOINT}/${id}`),
    userCourse: () => apiClient.get(`${ENDPOINT}/my-purchases`),
    coursePurchase: (id) => apiClient.get(`${ENDPOINT}/${id}/purchases`),
};

export const coursesApi_v1 = {
    getList: () => apiClient.get(ENDPOINT),
    getListActive: () => apiClient.get(`${ENDPOINT}/active`),
    getDetail: (id) => apiClient.get(`${ENDPOINT}/${id}`),
    create: (payload) => apiClient.post(ENDPOINT, payload),
    update: (payload) => apiClient.patch(`${ENDPOINT}/${payload.id}`, payload),
    delete: (id) => apiClient.delete(`${ENDPOINT}/${id}`),
    courseEnroll: (id, payload) => apiClient.post(`${ENDPOINT}/${id}/purchase`, payload),
    userCourse: () => apiClient.get(`${ENDPOINT}/my-purchases`),
    coursePurchase: (id) => apiClient.get(`${ENDPOINT}/${id}/purchases`),
};